<section class="page-container flex flex-column">
  <dx-scheduler timeZone="America/Guayaquil" [dataSource]="turns" [views]="['month', 'week', 'agenda']"
    [currentView]="agendaView" [showAllDayPanel]="false" [noDataText]="screen.labels.emptyTable"
    [shadeUntilCurrentTime]="true" [min]="today" [currentDate]="today" [startDayHour]="6" [endDayHour]="23"
    [cellDuration]="15" startDateExpr="turnDateTime" endDateExpr="endTurnDateTime" height="calc(100vh - 160px)"
    appointmentTemplate="appointmentTemplate" appointmentTooltipTemplate="tooltipTemplate"
    (onInitialized)="onAppointmentInitialized($event)" (onAppointmentFormOpening)="onAppointmentOpening($event)"
    (onAppointmentUpdating)="onAppointmentUpdating($event)" (onAppointmentDeleted)="onAppointmentDeleting($event)">

    <dxo-editing [allowAdding]="isCounter" [allowUpdating]="isCounter" [allowDeleting]="isCounter"
      [allowResizing]="false"></dxo-editing>

    <dxi-resource fieldExpr="id" [dataSource]="turnsResourceColor" [allowMultiple]="true" [useColorAsDefault]="true">
    </dxi-resource>

    <div *dxTemplate="let turnComponent of 'turnComponent'">
      <ms-common-turn-form [isPatch]="isPatch" [isPatchDoctor]="isPatchDoctor" [isPatchStatus]="isPatchStatus"
        [isAgenda]="true" [turnId]="turnId" [patientHelp]="patientHelp" [doctorHelp]="doctorHelp"
        [specialty]="specialtyName" [specialtyCodeAlt]="specialtyCodeAlt" [turnStart]="turnStart" [turnEnd]="turnEnd">
      </ms-common-turn-form>
    </div>

    <div *dxTemplate="let closeButton of 'closeButton'">
      <p-button icon="fas fa-times" styleClass="p-button-secondary p-button-outlined"
        (onClick)="closeAppointmentPopup()">
      </p-button>
    </div>

    <div *dxTemplate="let appTemplate of 'appointmentTemplate'">
      {{ appTemplate.appointmentData.patientName }}
    </div>

    <div *dxTemplate="let appTemplate of 'tooltipTemplate'">
      <div class="text-left">
        <label class="strong">{{ screen.labels.patient }}:</label>
        {{ appTemplate.appointmentData.patientName }}
      </div>
      <div class="text-left">
        <label class="strong">{{ screen.labels.doctor }}:</label>
        {{ appTemplate.appointmentData.doctorName }}
      </div>
      <div class="text-left">
        <label class="strong">{{ screen.labels.specialty }}:</label>
        {{ appTemplate.appointmentData.specialtyName }}
      </div>
      <div class="text-right">
        <p-button icon="far fa-trash-alt" styleClass="p-button-danger p-button-outlined"
          (onClick)="deleteAppointment(appTemplate.appointmentData)" *ngIf="isCounter">
        </p-button>

        <p-button icon="fas fa-notes-medical" styleClass="p-button-warning p-button-outlined"
          (onClick)="goToConsult(appTemplate.appointmentData, true)" [pTooltip]="screen.actions.care"
          *ngIf="isVital && appTemplate.appointmentData.turnStatusCodeAlt?.toLowerCase() === 'vital'">
        </p-button>

        <p-button icon="fas fa-notes-medical" styleClass="p-button-success p-button-outlined"
          (onClick)="goToConsult(appTemplate.appointmentData)" [pTooltip]="screen.actions.care"
          *ngIf="isDoctor && appTemplate.appointmentData.turnStatusCodeAlt?.toLowerCase() === 'waiting' || appTemplate.appointmentData.turnStatusCodeAlt?.toLowerCase() === 'in-progress' ">
        </p-button>
      </div>
    </div>
  </dx-scheduler>
</section>